import { ComponentProps, FC } from 'react'
import {
  TableProperties,
  Zap,
  Database,
  MessageSquareText,
  File,
  AlertTriangle,
  HelpCircle,
  Grid2X2Plus,
  Users,
} from 'lucide-react'
import { QuotaType } from '@bpinternal/const'

export type ProductType = QuotaType | 'team' | 'plus'

type Props = {
  productQuotaName: QuotaType
} & ReactIconProps

type ReactIconProps = ComponentProps<typeof Zap>

const icon: Record<QuotaType, FC<ReactIconProps>> = {
  table_row_count: TableProperties,
  knowledgebase_vector_storage: Database,
  storage_count: File,
  workspace_member_count: Users,
  always_alive: Zap,
  invocation_calls: MessageSquareText,
  bot_count: Grid2X2Plus,

  //NOT IMPLEMENTED
  ai_spend: HelpCircle,
  bing_search_spend: HelpCircle,
  integrations_owned_count: HelpCircle,
  invocation_timeout: HelpCircle,
  openai_spend: HelpCircle,
  workspace_ratelimit: HelpCircle,
}

export const ProductIcon = ({ productQuotaName, ...props }: Props) => {
  const Icon = productQuotaName ? icon[productQuotaName] : null

  return Icon ? <Icon {...props} /> : <AlertTriangle {...props} />
}
